<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <b-container fluid>
      <b-row>
        <b-col>
          <b-card header-tag="header">
            <template #header>
              <div class="titulos">
                  <div class="seccionTitle">
                    <em class="fa fa-cog mLeft"></em>
                    <div class="headerTxt mLeft">
                      <b-icon class="icono" icon="file-text"></b-icon>Administración de Cuentas
                    </div>
                  </div>
                  <div class="seccionCodigo">
                    <div>Admin_cuentas</div>
                  </div>
                </div>
            </template>
            <b-card-body>
              <b-row>
                <b-col align="left"> </b-col>
                <b-col
                  align="right"
                  v-if="$localStorageService.can('CP_01_agregar_cuenta')"
                >
                  <b-button
                    variant="outline-success"
                    @click="showModalAgregar()"
                    >Agregar</b-button
                  >
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <br />
                  <label>Filtrar Cuentas: </label>
                  <v-select
                    label="nombreCuenta"
                    id="busquedaCuenta"
                    v-model="cuentaBuscada"
                    :options="listadoCuentas"
                    @input="seleccionarCuenta($event)"
                  >
                    <template #option="{ nombreCuenta }">
                      <label>{{ nombreCuenta }}</label>
                    </template>
                    <span slot="no-options">No hay datos...</span>
                  </v-select>
                  <br /><br />

                  <b-table
                    hover
                    responsive
                    thead-tr-class="columnas"
                    class="parrafos"
                    id="tabla_listadoCuentas"
                    :items="listadoCuentasProcesada"
                    :fields="fields"
                    :per-page="registrosPorPagina"
                    :current-page="paginaActual"
                  >
                    <template v-slot:cell(cuentaActiva)="row">
                      <b-alert
                        variant="success"
                        show
                        v-if="row.item.cuentaActiva"
                        >ACTIVO</b-alert
                      >
                      <b-alert variant="secondary" show v-else
                        >INACTIVO</b-alert
                      >
                    </template>

                    <template v-slot:cell(empresaActiva)="row">
                      <p v-if="row.item.empresaActiva">ACTIVO</p>
                      <p v-else>INACTIVO</p>
                    </template>
                    <template v-slot:cell(Acciones)="row">
                      <b-button-group>
                        <b-button
                          v-if="$localStorageService.can('CP_01_edit_cuenta')"
                          title="Modificar Cuenta"
                          size="sm"
                          variant="outline-warning"
                          @click="editarCuenta(row.item)"
                          ><em class="fa fa-pencil"></em
                        ></b-button>

                        <b-button
                          v-if="
                            $localStorageService.can('CP_01_desac_cuenta') &&
                            row.item.cuentaActiva != false &&
                            row.item.cuentaActiva != null
                          "
                          title="Inactivar Cuenta"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivar(row.item.idCuenta, false)"
                        >
                          <b-icon icon="arrow-down"></b-icon
                        ></b-button>

                        <b-button
                          v-if="
                            $localStorageService.can('CP_01_act_cuenta') &&
                            row.item.cuentaActiva != true
                          "
                          title="Activar Cuenta"
                          variant="outline-success"
                          size="sm"
                          @click="activarDesactivar(row.item.idCuenta, true)"
                        >
                          <b-icon icon="arrow-up"></b-icon
                        ></b-button>
                      </b-button-group>
                    </template>

                    <template v-slot:cell(planes)="row">
                      <b-button
                        @click="
                          showModal(row.item.idCuenta, row.item.nombreCuenta)
                        "
                        variant="outline-info"
                        >Ver Planes</b-button
                      >
                    </template>
                    <template v-slot:cell(fechaModificacion)="row">
                      {{ row.item.fechaModificacion | formatoFecha }}
                    </template>
                  </b-table>
                  <b-pagination
                    v-if="
                      listadoCuentasProcesada !== undefined &&
                      listadoCuentasProcesada.length > 15
                    "
                    align="center"
                    v-model="paginaActual"
                    :total-rows="listadoCuentasProcesada.length"
                    :per-page="registrosPorPagina"
                    aria-controls="tabla_planes_convenios"
                  ></b-pagination>
                </b-col>
              </b-row>

              <b-modal
                ref="planes"
                :title="
                  'Planes de la cuenta: ' +
                  cuentaEnModal +
                  ' (Total Planes:' +
                  planeslistaPorCuenta.length +
                  ')'
                "
                hide-footer
                size="xl"
              >
                <br />
                <b-table
                  hover
                  responsive
                  thead-tr-class="columnas"
                  class="parrafos"
                  id="tabla_planeslistaPorCuentas"
                  :items="planeslistaPorCuenta"
                  :fields="fieldsPlanes"
                >
                  <template v-slot:cell(registroActivo)="row">
                    <b-alert
                      variant="success"
                      show
                      v-if="row.item.registroActivo"
                      >ACTIVO</b-alert
                    >
                    <b-alert variant="secondary" show v-else>INACTIVO</b-alert>
                  </template>
                  <template v-slot:cell(fechaModificacion)="row">
                    {{ row.item.fechaModificacion | formatoFecha }}
                  </template>
                </b-table>
                <br />
                <b-button
                  class="mt-3"
                  variant="outline-info"
                  block
                  @click="hideModal()"
                  >Cerrar</b-button
                >
                <br /><br />
              </b-modal>
              <br /><br /><br /><br />
            </b-card-body>
            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-modal
          ref="agregar"
          :title="tituloModal"
          hide-footer
          size="xl"
        > 
          
          <b-row>
            <b-col cols="12">
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(postCuenta)">
                  <b-col cols="12">
                    <br />
                    <label>Empresa:</label>
                    <br />
                    <validation-provider
                      name="validacion"
                      :rules="{ required: true }"
                      v-slot="motivoSlot"
                    >
                      <v-select
                        id="empresa"
                        name="empresa"
                        placeholder="Selecciona una empresa"
                        :options="listaEmpresas"
                        label="nombreComercial"
                        :reduce="(item) => item.idEmpresa"
                        v-model="agregarIdEmpresa"
                        :state="
                          motivoSlot.errors[0]
                            ? false
                            : motivoSlot.valid
                            ? true
                            : null
                        "
                        required
                      >
                        <span slot="no-options"
                          >No hay valores disponibles</span
                        >
                      </v-select>
                      <validacion
                        :texto="
                          motivoSlot.errors[0] ? motivoSlot.errors[0] : ''
                        "
                      ></validacion>
                    </validation-provider>
                  </b-col>

                  <b-col cols="12">
                    <br />
                    <label>Nombre Cuenta:</label>
                    <br />
                    <validation-provider
                      name="validacion"
                      :rules="{ required: true }"
                      v-slot="motivoSlot"
                    >
                      <b-form-input
                        placeholder="Ingresa el nombre "
                        v-model="agregarNombreCuenta"
                        required
                        maxlength="190"
                      ></b-form-input>

                      <validacion
                        :texto="
                          motivoSlot.errors[0] ? motivoSlot.errors[0] : ''
                        "
                      ></validacion>
                    </validation-provider>
                  </b-col>

                  <br /><br />
                  <b-button
                    variant="outline-success"
                    type="submit"
                    block
                    v-if="editar"
                    >Editar</b-button
                  >
                  <b-button variant="outline-success" type="submit" block v-else
                    >Guardar</b-button
                  >
                  <b-button
                    class="mt-3"
                    variant="outline-info"
                    block
                    @click="hideModalAgregar()"
                    >Cerrar</b-button
                  >
                </b-form>
              </validation-observer>
            </b-col>
          </b-row>
          <br />

          <br />
          <br /><br />
        </b-modal>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "AdminCuentas",
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    listadoCuentas: [],
    listadoCuentasProcesada: [],
    fields: [
      { key: "idCuenta", label: "Id", sortable: true },
      { key: "nombreCuenta", label: "Nombre", sortable: true },
      { key: "cuentaActiva", label: "Estatus de la Cuenta", sortable: true },
      {
        key: "nombreEmpresa",
        label: "Empresa/aseguradora/broker",
        sortable: true,
      },
      { key: "empresaActiva", label: "Estatus de la Empresa ", sortable: true },
      { key: "planes", label: "Ver Planes de la Cuenta", sortable: true },
      {
        key: "nombreUsuarioModifica",
        label: "Usuario Modificación",
        sortable: true,
      },
      { key: "fechaModificacion", label: "Fecha Modificación", sortable: true },
      "Acciones",
    ],
    loading: false,
    registrosPorPagina: 25,
    paginaActual: 1,
    cuentaEnModal: null,
    planeslistaPorCuenta: [],
    fieldsPlanes: [
      { key: "idPlan", label: "Id", sortable: true },
      { key: "nombrePlan", label: "Nombre", sortable: true },
      { key: "registroActivo", label: "Estatus", sortable: true },
      { key: "nombreCobertura", label: "Cobertura", sortable: true },
      {
        key: "vigenciaSeleccionada",
        label: "Vigencia Seleccionada	",
        sortable: true,
      },
      {
        key: "usuarioModificacion",
        label: "Usuario Modificación",
        sortable: true,
      },
      {
        key: "fechaModificacion",
        label: "Fecha Modificación",
        sortable: true,
      },
    ],
    cuentaBuscada: [],
    agregarIdCuenta: null,
    agregarIdEmpresa: null,
    agregarNombreCuenta: null,
    listaEmpresas: [],
    listaEmpresasTodas: [],
    editar: false,
    tituloModal : "Agregar una nueva cuenta", 
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerCuentas();
    this.obtenerEmpresasActivas();
    this.obtenerEmpresasTodas();
  },
  methods: {
    obtenerCuentas() {
      this.loading = true;
      this.listadoCuentas = [];
      this.listadoCuentasProcesada = [];
      this.$http
        .get(this.$api + "empresas/obtener/cuentas/sinestatus")
        .then((response) => {
          if (response.data.data) {
            this.listadoCuentas = response.data.data;
            this.listadoCuentasProcesada = response.data.data;
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    showModal(idCuenta, nombre) {
      this.cuentaEnModal = nombre;
      this.obtenerPlanesPorIdCuenta(idCuenta);
      this.$refs["planes"].show();
    },
    hideModal() {
      this.$refs["planes"].hide();
    },
    obtenerPlanesPorIdCuenta(idCuenta) {
      this.planeslistaPorCuenta = [];
      this.loading = true;
      const parametros = {idCuenta: idCuenta}
      this.$http
        .post(
          this.$api +
            "empresas/obtener/planesconvenios/porcuenta/sinestatus", parametros
        )
        .then((response) => {
          if (response.data.data) {
            this.planeslistaPorCuenta = response.data.data;
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    activarDesactivar(idCuenta, act_inac) {
      const _this = this;
      this.loading = true;
      this.$http
        .put(
          this.$api +
            "empresas/actualizarestatus/cuenta?idCuenta=" +
            idCuenta +
            "&estatus=" +
            act_inac
        )
        .then((response) => {
          this.obtenerCuentas();
          _this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
        })
        .catch(function (error) {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al actualizar la cuenta";
          _this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    seleccionarCuenta(cuenta) {
      this.listadoCuentasProcesada = [];
      if (cuenta == null) {
        this.listadoCuentasProcesada = this.listadoCuentas;
      } else {
        this.listadoCuentas.forEach((element) => {
          if (element.idCuenta == cuenta.idCuenta) {
            this.listadoCuentasProcesada.push(element);
          }
        });
      }
    },
    showModalAgregar() {
      if (this.editar == false) {
        this.agregarIdEmpresa = null;
        this.agregarNombreCuenta = null;
        this.agregarIdCuenta = null;
        this.tituloModal = "Agregar una nueva cuenta";
      } else {
        this.tituloModal = "Editar cuenta";        
      }
      this.$refs["agregar"].show();
    },
    hideModalAgregar() {
      this.editar = false;
      this.agregarIdEmpresa = null;
      this.agregarIdEmpresa = null;
      this.agregarNombreCuenta = null;
      this.tituloModal = "Agregar una nueva cuenta";
      this.$refs["agregar"].hide();
    },

    obtenerEmpresasActivas() {
      this.listaEmpresas = [];
      const parametros = {estatus: true}
      this.$http
        .post(this.$api + "empresas/obtener/porestatus", parametros)
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.listaEmpresas = respuesta.data.data;
          }
        });
    },
    postCuenta() {
      if (this.editar == true) {
        this.putCuenta();
      } else {
        const _this = this;
        var params = {
          nombreCuenta: this.agregarNombreCuenta,
          idEmpresa: this.agregarIdEmpresa,
          idUsuarioModifica: this.$localStorageService.getIdUsuario(),
        };

        this.$http
          .post(this.$api + "empresas/crear/cuenta", params)
          .then((response) => {
            _this.$swal.fire({
              icon: "success",
              title: "Aviso",
              text: response.data.message,
            });
          })
          .catch((error) => {
            var message = error.response.data.message
              ? error.response.data.message
              : "Error al crear la cuenta";
            _this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: message,
            });
          })
          .finally(() => (this.hideModalAgregar(), this.obtenerCuentas()));
      }
    },
    putCuenta() {
      const _this = this;
      var params = {
        idCuenta : this.agregarIdCuenta,
        nombreCuenta: this.agregarNombreCuenta,
        idEmpresa: this.agregarIdEmpresa.idEmpresa,
        idUsuarioModifica: this.$localStorageService.getIdUsuario(),
      };

      this.$http
        .put(this.$api + "empresas/actualizar/cuenta", params)
        .then((response) => {
          _this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
          });
        })
        .catch((error) => {
          var message = error.response.data.message
            ? error.response.data.message
            : "Error al crear la cuenta";
          _this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });
        })
        .finally(() => (this.hideModalAgregar(), this.obtenerCuentas()));
    },

    obtenerEmpresasTodas() {
      this.listaEmpresas = [];
      this.$http.get(this.$api + "empresas/obtener").then((respuesta) => {
        if (respuesta.data.data) {
          this.listaEmpresasTodas = respuesta.data.data;
        }
      });
    },

    editarCuenta(cuenta) {
      this.editar = true; 
      this.agregarIdCuenta = cuenta.idCuenta;
      this.listaEmpresasTodas.forEach((elemento) => {
        if (elemento.idEmpresa == cuenta.idEmpresa) {
          this.agregarIdEmpresa = elemento;          
        }
      });
      this.agregarNombreCuenta = cuenta.nombreCuenta;

      this.showModalAgregar();
    },
  },
};
</script>

<style scoped>
</style>
